<div class="root-container">
  <aside>
    <icn-sidebar-nav [items]="navigationItems"></icn-sidebar-nav>
  </aside>

  <div class="main-panel">
    <router-outlet></router-outlet>
  </div>
</div>
